module.exports = __webpack_public_path__ + "static/img/right-bottom-row-1.144199bf.png";